<div class="content-container">
  <div class="content-area">
    <div class="clr-row">
      <div class="clr-col-lg-4 clr-col-12">
        <div class="card">
          <div class="card-header">
            Продукт
          </div>
          <div class="card-block">
            <form clrForm [formGroup]="filterForm">
              <clr-input-container>
                <label>Код</label>
                <input clrInput formControlName="PartNumber" autocomplete="off" />
                <clr-control-error *clrIfError="'required'">Грешка</clr-control-error>
              </clr-input-container>

              <clr-input-container>
                <label>Количество</label>
                <input clrInput formControlName="quantity" autocomplete="off" />
                <clr-control-error *clrIfError="'required'">Грешка</clr-control-error>
              </clr-input-container>


            </form>
          </div>
          <div class="card-footer">
            <button class="btn btn-primary" type="submit" (click)="loadTree()">Зареди</button>
            <button class="btn" type="button" (click)="resetForm()">Изчисти</button>
          </div>
        </div>
      </div>
      <div class="clr-col-lg-8 clr-col-12">
        <clr-tabs>
          <clr-tab>
            <button clrTabLink>Продуктова структура</button>
            <ng-template [(clrIfActive)]="tehnologieChoose">
              <clr-tab-content>
                <subproducts-tree *ngIf="processRecipe" [recepiesToProcess]="recepiesToProcess" [parent]="this">
                </subproducts-tree>
              </clr-tab-content>
            </ng-template>
          </clr-tab>
          <clr-tab>
            <button clrTabLink>Типове продукти</button>
            <ng-template [(clrIfActive)]="productTypeChoose">
              <clr-tab-content>
                <product-type-grid [tree]="tree"></product-type-grid>
              </clr-tab-content>
            </ng-template>
          </clr-tab>
          <clr-tab>
            <button clrTabLink>Групирани продукти</button>
            <ng-template [(clrIfActive)]="productTypeGroupedChoose">
              <clr-tab-content>
                <product-type-grid-grouped [tree]="tree"></product-type-grid-grouped>
              </clr-tab-content>
            </ng-template>
          </clr-tab>
        </clr-tabs>
      </div>
    </div>
  </div>
</div>